var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [
    [_c('h3', [_vm._v("文件上传")]), _vm._v(" "), _c('div', {
      staticClass: "bs-docs-section"
    }, [_c('div', {
      staticClass: "bs-example"
    }, [_c('h4', [_vm._v("单个文件上传")]), _vm._v(" "), _c('p', [_c('n3-uploader', {
      attrs: {
        "url": "http://test.com/",
        "multiple": false,
        "max-size": 0.5
      },
      on: {
        "error": _vm.onError
      }
    })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("点击上传")]), _vm._v(" "), _c('p', [_c('n3-uploader', {
      attrs: {
        "url": "http://test.com/"
      },
      on: {
        "error": _vm.onError
      }
    })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("支持拖拽")]), _vm._v(" "), _c('p', [_c('n3-uploader', {
      attrs: {
        "type": "drag",
        "url": "http://test.com/"
      },
      on: {
        "error": _vm.onError
      }
    })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', [_vm._v("参数")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', [_vm._v("Events")]), _vm._v(" "), _vm._m(2)])]
  ], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-html"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-comment"
    }
  }, [_vm._v("<!-- 单个上传 -->")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-uploader")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("url")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"http://test.com/\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":multiple")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"false\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("@error")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"onError\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":max-size")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"0.5\"")]), _vm._v(">")]), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-uploader")]), _vm._v(">")]), _vm._v("\n\n"), _c('span', {
    attrs: {
      "class": "hljs-comment"
    }
  }, [_vm._v("<!-- 点击上传 -->")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-uploader")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("url")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"http://test.com/\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("@error")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"onError\"")]), _vm._v(">")]), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-uploader")]), _vm._v(">")]), _vm._v("\n\n"), _c('span', {
    attrs: {
      "class": "hljs-comment"
    }
  }, [_vm._v("<!-- 拖拽上传 -->")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-uploader")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"drag\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("url")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"http://test.com/\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("@error")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"onError\"")]), _vm._v(">")]), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-uploader")]), _vm._v(">")]), _vm._v("\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("name")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("files")]), _vm._v(" "), _c('td', [_vm._v("文件对象的name")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")]), _vm._v("："), _c('code', {
    pre: true
  }, [_vm._v("click")]), _vm._v(" 或 "), _c('code', {
    pre: true
  }, [_vm._v("drag")])]), _vm._v(" "), _c('td', [_vm._v("click")]), _vm._v(" "), _c('td', [_vm._v("拖拽或者点击")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("accept")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("'' (全支持)")]), _vm._v(" "), _c('td', [_vm._v("支持的文件类型 例如: "), _c('code', {
    pre: true
  }, [_vm._v("'image/jpeg'")]), _vm._v(" 或者 "), _c('code', {
    pre: true
  }, [_vm._v("'image'")]), _vm._v("支持所有图片格式,多个如 "), _c('code', {
    pre: true
  }, [_vm._v("'txt|image|mp3'")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("url")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("上传地址")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("params")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("上传参数")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("multiple")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_vm._v("支持多文件上传")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("drag-width")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("300px")]), _vm._v(" "), _c('td', [_vm._v("拖拽框宽度")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("drag-height")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("200px")]), _vm._v(" "), _c('td', [_vm._v("拖拽框高度")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("max-length")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td', [_vm._v("上传文件个数限制")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("with-credentials")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("跨域时带cookies")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("max-size")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td', [_vm._v("单个文件的size限制（MB）")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("事件名称")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("回调参数")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("success")]), _vm._v(" "), _c('td', [_vm._v("成功上传回调时")]), _vm._v(" "), _c('td', [_vm._v("({response, file})")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("finish")]), _vm._v(" "), _c('td', [_vm._v("完成所有上传任务时")]), _vm._v(" "), _c('td', [_vm._v("()")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("delete")]), _vm._v(" "), _c('td', [_vm._v("删除一个上传的项目时")]), _vm._v(" "), _c('td', [_vm._v("(uploadItem)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("error")]), _vm._v(" "), _c('td', [_vm._v("发生错误时")]), _vm._v(" "), _c('td', [_vm._v("({message, file})")])])])])
}]
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-44da4490", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44da4490"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/lib/markdown-compiler.js?raw!./docs/example_zh/n3UploaderDocs.md
// module id = 889
// module chunks = 0